import { cn } from '@/lib/utils';
import { formatPrice } from '@/utils/formatters.ts';
import { MoneyValueDto } from '@/types/MoneyValueDto.ts';
import { InfoCardRow } from '@/components/ui/InfoCard.tsx';

interface BookingStateMoneyRowProps {
  label: string;
  value: MoneyValueDto;
  /** Wpłaty stoją cieniej niż wartość i saldo — nie są celem tej karty. */
  strong?: boolean;
  /** Kreska nad wierszem — oddziela kolejną walutę od poprzedniej. */
  divided?: boolean;
}

const BookingStateMoneyRow = ({
  label,
  value,
  strong = true,
  divided = false,
}: BookingStateMoneyRowProps) => (
  <InfoCardRow divided={divided} label={label}>
    <span className={cn('tabular-nums text-ink', strong && 'font-semibold')}>
      {formatPrice(value.amount, value.currency)}
    </span>
  </InfoCardRow>
);

export default BookingStateMoneyRow;
